import { Injectable } from '@angular/core';
import { BackendService } from '../new-http/backend.service';
import { GetUserAcceptanceTermResponse, SetUserAcceptanceTerm } from '../../interfaces/operational-limit/operational-limit.interface';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class OperationalLimitService extends BackendService {
    public getUserAcceptanceTerm(cblc: number): Observable<GetUserAcceptanceTermResponse> {
        return this.webapi.get<GetUserAcceptanceTermResponse>('/operational-limit/acceptance-term/' + cblc);
    }
    public setUserAcceptanceTerm(userAccount: SetUserAcceptanceTerm): Observable<any> {
        return this.webapi.post('/operational-limit/acceptance-term/accept', userAccount);
    }
    public rejectUserAcceptanceTerm(cblc: number): Observable<any> {
        return this.webapi.post('/operational-limit/acceptance-term/reject', cblc);
    }
}